function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { getSeparatorByCurrency } from "../../utils/currency";
import ReactCurrencyInput from "react-currency-input-field";

var CurrencyInput = function CurrencyInput(props) {
  var currency = props.currency;
  var currencyInput = getSeparatorByCurrency(currency);
  return /*#__PURE__*/React.createElement(ReactCurrencyInput, _extends({}, props, {
    decimalsLimit: currencyInput.decimalLimit,
    prefix: currencyInput.prefix,
    suffix: currencyInput.suffix,
    decimalSeparator: currencyInput.decimalSeparator,
    groupSeparator: currencyInput.groupSeparator // Not working as intended (does not work)
    //decimalScale={currencyInput.decimalScale}
    // Only workin on blur, and is wonky:
    //fixedDecimalLength={currencyInput.fixedDecimalLength}

  }));
};

export default CurrencyInput;